// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CartsDataViewContext } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { pluralize } from "@tps/XDL/Utilities";
import React, { FC, useContext } from "react";

export interface SavedOrdersCountStyles {
    productCountText?: TypographyProps;
}
export const savedOrdersCountStyles: SavedOrdersCountStyles = {};

const styles = savedOrdersCountStyles;

const SavedOrdersCount: FC<WidgetProps> = () => {
    const SavedOrdersDataView = useContext(CartsDataViewContext);

    let totalItemCount = 0;

    if (SavedOrdersDataView.value && SavedOrdersDataView.pagination) {
        totalItemCount = SavedOrdersDataView.pagination.totalItemCount;
    }

    if (!totalItemCount) {
        return null;
    }

    return (
        <Typography className="product-count-wrapper" {...styles.productCountText}>
            {pluralize(totalItemCount, translate("Order"), {
                showNumber: true,
            })}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: SavedOrdersCount,
    definition: {
        group: "Saved Order List",
        displayName: "Saved Orders Count",
        allowedContexts: ["SavedOrderListPage"],
    },
};

export default widgetModule;
